__turbopack_context__.v({
  "menuItem": "CreateConnectionAction-module__kkprrG__menuItem",
  "menuItemDescription": "CreateConnectionAction-module__kkprrG__menuItemDescription",
  "menuItemRow": "CreateConnectionAction-module__kkprrG__menuItemRow",
  "menuItemText": "CreateConnectionAction-module__kkprrG__menuItemText",
  "menuItemTitle": "CreateConnectionAction-module__kkprrG__menuItemTitle",
});
